import React, { useState } from "react"
import PropTypes from "prop-types"
import { Row, Col, Card, Typography, List, Avatar, Button, Tag, Flex, Dropdown, Menu, Spin } from "antd"
import {
  UserOutlined,
  ShareAltOutlined,
  EditOutlined,
  InfoCircleOutlined,
  MoreOutlined,
  DeleteOutlined,
  FileTextOutlined,
  QuestionCircleOutlined
} from "@ant-design/icons"
import WaiverUploaded from "../../../../../assets/icons/waiver-uploaded.svg"
import WaiverNotSigned from "../../../../../assets/icons/waiver-not-signed.svg"
import Questionnaire from "../../../../../assets/icons/questionnaire.svg"
import styles from "../../index.module.css"
import { GreenCheckIcon, QuestionnaireIcon, RemoveQuestionnaireIcon } from "icons"
import { Plus } from "react-feather"
import { WaiverDetailsModal } from "pagesV2/pro/Embedded/BookingConfirmation/modal/WaiverDetails"
import CustomQuestions from "pagesV2/pro/Embedded/BookingConfirmation/modal/CustomQuestions"
import { getSharedWaiver } from "store/digital-waiver"
const { Text } = Typography

const MembersCard = React.memo(
  ({setIsShowSignForChildWaiver,uuid,isShowGuestSubmission, tripBookingId, booking_questionnaire, fullName, guests = [], loading, onInviteWaiver, onSignChildWaiver, onAddGuest, childCount }) => {
    const [showCustomQuestionsModal, setShowCustomQuestionsModal] = useState(false)
    const [isShowWaiverDetailsModal, setIsShowWaiverDetailsModal] = useState(false)
    const [currentDocumentIndex, setCurrentDocumentIndex] = useState(0)
    const [isShowLoading,setIsShowLoading] = useState(false)
    const [record, setRecord] = useState(null)
    console.log(record, "recorkfdkjfkd")
    const handleMenuClick = (e, guest) => {
      switch (e.key) {
        case "open-waiver":
          setIsShowWaiverDetailsModal(true)
          setIsShowLoading(true)
          setRecord(guest)
          // Handle opening waiver
          console.log("Open waiver for:", guest.name)
          break
        case "open-questionnaire":
          setShowCustomQuestionsModal(true)
          break
           case "sign-for-child":
          setIsShowSignForChildWaiver(true)
          break
        case "remove-guest":
          // Handle removing guest
          console.log("Remove guest:", guest.name)
          break
        default:
          break
      }
    }

    const getMenuItems = (guest, index) => {
      console.log(guest, "guestguest")
      const items = []

      if (guest.status === "Signed") {
        items.push({
          key: "open-waiver",
          icon: <FileTextOutlined />,
          label: "Open waiver"
        })
      } else if (guest.participant_type === "Child") {
        items.push({
          key: "sign-for-child",
          icon: <FileTextOutlined />,
          label: "Sign for child"
        })
      }

      if (booking_questionnaire?.id && index === 0) {
        items.push({
          key: "open-questionnaire",
          icon: <QuestionCircleOutlined />,
          label: booking_questionnaire?.status === "submitted" ? "Edit Questionnaire" : "Open questionnaire"
        })
      }

      items.push(
        {
          type: "divider"
        },
        {
          key: "remove-guest",
          icon: <DeleteOutlined />,
          label: "Remove guest",
          danger: true
        }
      )

      return items
    }
    console.log(getMenuItems, "getMenuItemsgetMenuItems")
    return (
      <>
        <Card className={styles.mainCard} title="Members">
          <Text type="secondary" className="mb-3xl block">
            A few easy steps: sign the waiver, answer a few questions, and you're all set to go.
          </Text>
          <div className={`${styles.sectionTitle} mb-m`}>Required Actions (2)</div>
          <div className={styles.infoAlert}>
            <span className={styles.infoIcon}>
              <InfoCircleOutlined />
            </span>
            <span>You must fill in the guest information and sign the waiver before the start of the trip.</span>
          </div>
          <Row gutter={16} className="mb-xl">
            <Col span={12}>
              <Card className={styles.waiverCard} onClick={onInviteWaiver}
              >
                <ShareAltOutlined className={`${styles.waiverCardIcon} text-color-primary mb-xxs`} />
                <div className={`${styles.waiverCardTitle} text-color-primary`}>Invite to sign waiver</div>
                <div className={`${styles.waiverCardRequired} color-text-secondary-dark`}>(required)</div>
              </Card>
            </Col>
            <Col span={12}>
              <Card
                className={`${styles.waiverCard} ${childCount === 0 || isShowGuestSubmission ? styles.disabledCard : "cursor-pointer"}`}
                onClick={isShowGuestSubmission ? undefined : onSignChildWaiver}
                style={{ 
                  opacity: isShowGuestSubmission ? 0.5 : 1,
                  cursor: isShowGuestSubmission ? 'not-allowed' : 'pointer'
                }}
              >
                <EditOutlined className={`${styles.waiverCardIcon} text-color-primary`} />
                <div className={`${styles.waiverCardTitle} text-color-primary`}>Sign waiver</div>
                <div className={`${styles.waiverCardRequired} color-text-secondary-dark`}>(required)</div>
              </Card>
            </Col>
          </Row>
          <Flex className="mt-3xl mb-m" justify="space-between" align="center" gap={10}>
            <div className={`${styles.sectionTitle}`}>Guests ({guests.length})</div>
          </Flex>
          <Spin spinning={loading} style={{ width: "100%" }}>
            <List
              itemLayout="horizontal"
              dataSource={guests}
              renderItem={(guest, index) => (
                <List.Item
                  className={styles.guestItem}
                  actions={[
                    <Dropdown
                      menu={{
                        items: getMenuItems(guest, index),
                        onClick: (e) => handleMenuClick(e, guest)
                      }}
                      trigger={["click"]}
                      placement="bottomRight"
                    >
                      <MoreOutlined className={`${styles.moreIcon} cursor-pointer`} />
                    </Dropdown>
                  ]}
                >
                  <List.Item.Meta
                    className={styles.guestItemMeta}
                    avatar={<Avatar icon={<UserOutlined />} />}
                    title={<span className={`${styles.guestName} fw-500`}>{guest.name}</span>}
                    description={<span className={`${styles.guestType}`}>{guest.participant_type || "Child"}</span>}
                  />
                  <div className={styles.questionnaireStatusBox}>
                    <div
                      className={`${booking_questionnaire?.status === "submitted" ? "Completed" : "Not completed"} commonBox questionnaire`}
                    >
                      {booking_questionnaire?.id &&
                        index === 0 &&
                        (booking_questionnaire.status === "submitted" ? (
                          <div className="relative">
                            <img src={Questionnaire} alt="waiver_uploaded" />
                            <GreenCheckIcon className="absolute" />
                          </div>
                        ) : (
                          <div className="relative">
                            <img src={WaiverNotSigned} alt="waiver_not_signed" />
                            <RemoveQuestionnaireIcon className="absolute" />
                          </div>
                        ))}
                      {booking_questionnaire?.id && index === 0 && (
                        <div>
                          <div className="fw-500">Questionnaire</div>
                          <span>{booking_questionnaire.status === "submitted" ? "Completed" : "Not completed"}</span>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className={styles.waiverStatusBox}>
                    <div className={`${guest.status === "Signed"} commonBox`}>
                      {guest.status === "Signed" ? (
                        <div className="relative">
                          <img src={WaiverUploaded} alt="waiver_uploaded" />
                          <GreenCheckIcon className="absolute" />
                        </div>
                      ) : (
                        <div className="relative">
                          <img src={WaiverNotSigned} alt="waiver_not_signed" />
                          <RemoveQuestionnaireIcon className="absolute" />
                        </div>
                      )}
                      <div>
                        <div className="fw-500">Waiver</div>
                        <span>{guest.status === "Signed" ? "Signed" : "Not signed"}</span>
                      </div>
                    </div>
                  </div>
                </List.Item>
              )}
            />
          </Spin>
        </Card>
        <CustomQuestions
        uuid={uuid}
          bookingQuestionnaireId={booking_questionnaire?.id}
          visible={showCustomQuestionsModal}
          onClose={() => setShowCustomQuestionsModal(false)}
        />
        {isShowWaiverDetailsModal && (
          <WaiverDetailsModal
           isShowLoading={isShowLoading}
           setIsShowLoading={setIsShowLoading}
            currentDocumentIndex={currentDocumentIndex}
            setCurrentDocumentIndex={setCurrentDocumentIndex}
            record={record}
            open={isShowWaiverDetailsModal}
            onCancel={() => {
              setIsShowWaiverDetailsModal(false)
              setCurrentDocumentIndex(0)
            }}
          />
        )}
      </>
    )
  }
)

MembersCard.propTypes = {
  tripBookingId: PropTypes.string,
  guests: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      type: PropTypes.string,
      waiver: PropTypes.string,
      questionnaire: PropTypes.string,
      main: PropTypes.bool
    })
  ),
  onInviteWaiver: PropTypes.func,
  onSignChildWaiver: PropTypes.func,
  onAddGuest: PropTypes.func
}

MembersCard.displayName = "MembersCard"

export default MembersCard
